const Instagram = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.1044 2.82812C5.13176 2.82812 2.71301 5.2483 2.71301 8.22168V15.9249C2.71301 18.8979 5.13319 21.317 8.10657 21.317H15.8098C18.7828 21.317 21.2019 18.8968 21.2019 15.9235V8.21951C21.2019 5.24687 18.7817 2.82812 15.8083 2.82812H8.1044ZM17.5041 5.78635C17.9124 5.78635 18.2437 6.11767 18.2437 6.5259C18.2437 6.93414 17.9124 7.26546 17.5041 7.26546C17.0959 7.26546 16.7646 6.93414 16.7646 6.5259C16.7646 6.11767 17.0959 5.78635 17.5041 5.78635ZM11.9575 7.26546C14.6088 7.26546 16.7646 9.42126 16.7646 12.0726C16.7646 14.7239 14.6084 16.8797 11.9575 16.8797C9.30615 16.8797 7.15035 14.7235 7.15035 12.0726C7.15035 9.42163 9.30615 7.26546 11.9575 7.26546ZM11.9575 8.74457C10.1193 8.74457 8.62946 10.2344 8.62946 12.0726C8.62946 13.9107 10.1193 15.4006 11.9575 15.4006C13.7956 15.4006 15.2855 13.9107 15.2855 12.0726C15.2855 10.2344 13.7956 8.74457 11.9575 8.74457Z"
            fill="white"
        />
    </svg>
);

export default Instagram;
